import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MotifIconModule, MotifThemeModule, MotifVerticalNavigationModule } from '@ey-xd/ng-motif';
import { NavigationItem } from '@models';
import { TranslateModule } from '@ngx-translate/core';
import { EytcAuthService } from '@services';

@Component({
  selector: 'app-side-bar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MotifThemeModule,
    MotifVerticalNavigationModule,
    MotifIconModule,
    TranslateModule,
  ],
  templateUrl: './side-bar.component.html',
  styleUrl: './side-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideBarComponent {
  public isOpen = input.required<boolean>();
  public topLinks = input.required<NavigationItem[]>();

  #authService = inject(EytcAuthService);

  public filteredTopLinks = computed(() => {
    const userRoles = this.#authService.userRoles();

    if (!userRoles) {
      return [];
    }

    return this.topLinks().filter((link: NavigationItem) => {
      if (link.roles) {
        return link.roles.some(role => userRoles.includes(role));
      }
      return true;
    });
  });
}
